export const sizes = [
  { id: 3, name: "1-3", min: 1, max: 3 },
  { id: 10, name: "4-10", min: 4, max: 10 },
  { id: 25, name: "11-25", min: 11, max: 25 },
  { id: 50, name: "26-50", min: 26, max: 50 },
  { id: 51, name: "50+", min: 51 },
];
